module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fb-title1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword#toc3a",
      "id": "toc3"
    }
  }, [_vm._v("Foreword by Robert B. Talisse")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/preface#toc4a",
      "id": "toc4"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#toc6a",
      "id": "toc6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p00v-001.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#toc7a",
      "id": "toc7"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#toc8a",
      "id": "toc8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p00v-002.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#toc9a",
      "id": "toc9"
    }
  }, [_vm._v("WASTED LIVES?")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#toc10a",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p00v-003.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#toc11a",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECTS OF WORTH?")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#toc12a",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p00v-004.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#toc13a",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOURISHING?")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#toc14a",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-005.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#toc15a",
      "id": "toc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THINGS THAT MATTER?")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#toc16a",
      "id": "toc16",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-006.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#toc17a",
      "id": "toc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORALITY AND HAPPINESS")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#toc18a",
      "id": "toc18",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-007.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#toc19a",
      "id": "toc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORALITY AND UNHAPPINESS")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#toc20a",
      "id": "toc20",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-008.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#toc21a",
      "id": "toc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARACTER")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#toc22a",
      "id": "toc22",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-009.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#toc23a",
      "id": "toc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPEARING MORAL")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#toc24a",
      "id": "toc24",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-010.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#toc25a",
      "id": "toc25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOD AND MORALITY")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#toc26a",
      "id": "toc26",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-011.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#toc27a",
      "id": "toc27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HEAVEN AND HELL")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#toc28a",
      "id": "toc28",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0vi-012.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#toc29a",
      "id": "toc29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORAL JUDGMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#toc30a",
      "id": "toc30",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-013.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#toc31a",
      "id": "toc31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORAL STANDARDS")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#toc32a",
      "id": "toc32",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-014.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#toc33a",
      "id": "toc33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHOOSING THE EXPERIENCE MACHINE")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#toc34a",
      "id": "toc34",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-015.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#toc35a",
      "id": "toc35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAPPINESS AND IGNORANCE")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#toc36a",
      "id": "toc36",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-016.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#toc37a",
      "id": "toc37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASSESSING ACHIEVEMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#toc38a",
      "id": "toc38",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-017.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#toc39a",
      "id": "toc39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLEASURES AND PAINS")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#toc40a",
      "id": "toc40",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-018.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#toc41a",
      "id": "toc41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEAR OF THE DIVINE")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#toc42a",
      "id": "toc42",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-019.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#toc43a",
      "id": "toc43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEAR OF UNFULFILLED DESIRES")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#toc44a",
      "id": "toc44",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii-020.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#toc45a",
      "id": "toc45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEAR OF DEATH")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#toc46a",
      "id": "toc46",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pviii-021.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#toc47a",
      "id": "toc47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUTILITY")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#toc48a",
      "id": "toc48",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pviii-022.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#toc49a",
      "id": "toc49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIVING WELL")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#toc50a",
      "id": "toc50",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pviii-023.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#toc51a",
      "id": "toc51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATISFACTION")])]), _vm._v(" "), _c('div', {
    staticClass: "display-imagec"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#toc52a",
      "id": "toc52",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pviii-024.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#toc53a",
      "id": "toc53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUDING QUESTIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/notes#toc55a",
      "id": "toc55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/index#toc59a",
      "id": "toc59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/authors#toc62a",
      "id": "toc62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0